import React from 'react';

const PeopleContentSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen rounded-xl dark:bg-secondary-dark">
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-4">
          <div className="h-7 bg-gray-200 dark:bg-gray-700 rounded w-48 animate-pulse"></div>
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-32 animate-pulse"></div>
        </div>

        {/* People Grid - Skeleton cards closely matching PeopleCard */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-6 items-stretch">
          {[...Array(12)].map((_, index) => (
            <div
              key={index}
              className="relative h-full"
            >
              <div
                className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 
                           transition-all duration-200 overflow-hidden relative h-full p-4"
              >
                {/* Header Section */}
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    {/* Avatar */}
                    <div className="w-10 h-10 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse"></div>

                    {/* Name and Email */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between gap-2 mb-1">
                        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 animate-pulse"></div>
                      </div>
                      <div className="h-3.5 bg-gray-200 dark:bg-gray-700 rounded w-40 animate-pulse"></div>
                    </div>
                  </div>

                  {/* Options button */}
                  <div className="w-7 h-7 rounded-lg bg-gray-100 dark:bg-gray-700 animate-pulse flex-shrink-0" />
                </div>

                {/* Skills Section - Single Line Only */}
                <div className="mb-3">
                  <div className="flex items-center gap-1.5">
                    <div className="h-6 rounded-full bg-gray-100 dark:bg-gray-700 w-20 animate-pulse"></div>
                    <div className="h-6 rounded-full bg-gray-100 dark:bg-gray-700 w-16 animate-pulse"></div>
                  </div>
                </div>

                {/* Teams Section */}
                <div className="border-t border-gray-100 dark:border-gray-700 pt-3">
                  <div className="flex items-center justify-between mb-2">
                    <div className="h-3.5 bg-gray-200 dark:bg-gray-700 rounded w-16 animate-pulse"></div>
                    <div className="h-3 w-10 bg-gray-100 dark:bg-gray-700 rounded animate-pulse"></div>
                  </div>

                  {/* Team indicators - compact dot-based approach */}
                  <div className="space-y-1.5">
                    {[0, 1, 2].map((t) => (
                      <div key={t} className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0 animate-pulse"></div>
                        <div className="h-3.5 bg-gray-200 dark:bg-gray-700 rounded flex-1 animate-pulse"></div>
                      </div>
                    ))}

                    {/* Remaining teams count */}
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600 flex-shrink-0"></div>
                      <div className="h-3.5 bg-gray-100 dark:bg-gray-700 rounded w-28 animate-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PeopleContentSkeleton; 